// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import VueLocalStorage from 'vue-localstorage'
import './assets/css/custom-en.css';
import vSelect from 'vue-select'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import InfiniteLoading from 'vue-infinite-loading'

// import { notificationSetup } from './util/notifications'
// notificationSetup()

Vue.use(InfiniteLoading)
// If you use Swiper 6.0.0 or higher
import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
import VCalendar from 'v-calendar';
// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});
// Services
Vue.config.productionTip = false
Vue.use(VueLocalStorage)
Vue.component('v-select', vSelect)
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('span', '✕'),
  }
});
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

export const bus = new Vue();

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
